import * as graphql from 'generated/graphql';

import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';

export default function useCompleteWorkspaceCheckpoint(key: string): () => Promise<void> {
	const workspace = useWorkspace();

	const [commit] = graphql.useCompleteWorkspaceCheckpointMutation({
		variables: {
			input: {
				workspaceID: workspace.id,
				key,
			},
		},
	});

	return async () => {
		await commit();
	};
}
